export interface PublicSharedLinkState {
  fetchingSharedLink: boolean;
  sharedLink: string | null;
}

export const CREATE_SHAREDLINK = 'CREATE_SHAREDLINK';
export const GET_SHAREDLINK_START = 'GET_SHAREDLINK_START';
export const GET_SHAREDLINK = 'GET_SHAREDLINK';
export const GET_SHAREDLINK_END = 'GET_SHAREDLINK_END';
export const CLEAR_PUBLIC_SHARED_LINK = 'CLEAR_PUBLIC_SHARED_LINK';

type CreateSharedLinkAction = {
  type: typeof CREATE_SHAREDLINK;
  payload: string;
}

type GetSharedLinkAction = {
  type: typeof GET_SHAREDLINK;
  payload: string | null;
}

type GetSharedLinkStartAction = {
  type: typeof GET_SHAREDLINK_START;
}

type GetSharedLinkEndAction = {
  type: typeof GET_SHAREDLINK_END;
}

type ClearPublicSharedLink = {
  type: typeof CLEAR_PUBLIC_SHARED_LINK;
}

export type PublicSharedLinkActionTypes =
  CreateSharedLinkAction |
  GetSharedLinkAction |
  GetSharedLinkStartAction |
  GetSharedLinkEndAction |
  ClearPublicSharedLink;
